import styled, { css } from 'styled-components';

export const Block = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding: 24px;
    gap: 16px;
    margin: 0 16px;
    max-width: 1000px;
    border: 1px solid ${theme.v2.colors.brand.primaryLowLight};
    box-shadow: 0px 4px 6px 0px ${theme.v2.colors.brand.primaryLowLight};

    @media (min-width: ${theme.v2.breakpoints.md}) {
      flex: 1;
    }
  `}
`;

export const BlockHeader = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const Subtitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      max-width: 400px;
    }
  `}
`;

export const ButtonWrapper = styled.div``;
